import { render, staticRenderFns } from "./BookEventHealthScreeningSlot.vue?vue&type=template&id=5b8ebfbe&"
import script from "./BookEventHealthScreeningSlot.vue?vue&type=script&lang=js&"
export * from "./BookEventHealthScreeningSlot.vue?vue&type=script&lang=js&"
import style0 from "./BookEventHealthScreeningSlot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports